import angular from 'angular';
import constants from 'app/constants';
import {
  oversightDataService,
  oversightSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import controller from './agendaItem-document.controller';
import directive from './agendaItem-document.directive';


export default angular.module('app.components.advisory.oversight.agendaItemDocument', [
  alerts,
  oversightDataService,
  oversightSharedModelService,
  confirmDialog,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('agendaItemDocument', directive)
  .controller('AgendaItemDocumentController', controller)
  .name;

console.log('app.components.advisory.oversight.agendaItemDocument created');
